import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#193446",
    viewBox: "0 0 24 24",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="m18.497 2.268 3.235 3.235a.915.915 0 0 1 0 1.294l-1.05 1.05-4.53-4.528 1.051-1.051a.915.915 0 0 1 1.294 0m-3.476 2.183 4.528 4.529L8.793 19.736 2 22l2.264-6.793z"/>' }
  })
);